<full-calendar #calendarRef [options]="calendarOptions"></full-calendar>
